<script>
export default {
    name: 'App',
};
</script>

<script setup>
import { ref } from 'vue';
import AppLayout from '@/layouts/layout.vue';
import AppMaintenance from '@/components/app/maintenance.vue';
import AppVersion from '@/components/app/version.vue';
import AppSurveyRegistration from '@/components/app/survey/registration.vue';
import AppSupportChatDrawer from '@/components/app/support-chat/components/drawer.vue';
import useSupportChat from '@/composables/useSupportChat';
import { forEachAppModule } from '@/modules/registry';
import { emitter } from '@/utils/event/emitter.ts';
import { APP } from '@/utils/event/constants.ts';

const modulesComponents = ref([]);

useSupportChat({
    openFromHash: true,
});

function initModulesSections() {
    const components = [];

    forEachAppModule((data, module) => {
        (data.use.components?.global ?? []).forEach((component) => {
            components.push({
                module,
                component,
            });
        });
    });

    modulesComponents.value = components;
}

initModulesSections();

emitter.on(APP.MODULES, initModulesSections);
</script>

<template>
    <div id="app" class="@container/app">
        <app-layout class="min-h-0">
            <router-view />
        </app-layout>
        <app-maintenance />
        <app-version />
        <app-survey-registration />
        <app-support-chat-drawer />

        <component
            v-for="{ module, component } in modulesComponents"
            :key="`${module}-${component}`"
            :is="component"
        />
    </div>
</template>
